<script setup lang="ts">
import Icon from '../Icon/Icon.vue'
import Modal from './Modal.vue'

defineEmits(['confirm', 'cancel'])
</script>

<template>
  <Modal
    :confirmButton="{
      text: 'Yes',
      confirm: () => $emit('confirm'),
    }"
    :cancelButton="{
      text: 'No',
      cancel: () => $emit('cancel'),
    }"
    :withCloseIcon="false"
    :withCloseShortcuts="false"
    :withFadeInAnimation="false"
  >
    <div class="grid place-content-center py-5">
      <div class="bg-error-10 grid h-12 w-12 place-content-center rounded-full">
        <Icon
          class="text-error-5"
          icon="check"
          size="2x"
        />
      </div>
    </div>
    <div class="pb-4 text-center text-sm">
      <div
        v-if="$slots.title"
        class="px-4 pb-2 text-lg font-bold"
      >
        <slot name="title" />
      </div>
      <div class="min-h-8">
        <slot>{{ !$slots.title ? 'Are you sure?' : $slots.default }}</slot>
      </div>
    </div>
  </Modal>
</template>
